module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }